import React from "react";
import { useTranslation } from "react-i18next";
import { ProductBadge } from "@dreamhub/designsystem/icons";
import { ProductTabEmptyState } from "./ProductTabEmptyState";

const TRANSLATION_KEY = "settings.product.productPage.servicesEmpty";

interface ServicesEmptyStateProps {
  onAddService: () => void;
}

export const ServicesEmptyState: React.FC<ServicesEmptyStateProps> = ({
  onAddService
}) => {
  const { t } = useTranslation();

  return (
    <ProductTabEmptyState
      // Scaled up so its hexagon matches the Bundles tab's.
      badge={<ProductBadge width={111} height={118} />}
      badgeClassName="-left-[26px] -top-[13px]"
      title={t(`${TRANSLATION_KEY}.title`)}
      subtitle={t(`${TRANSLATION_KEY}.subtitle`)}
      actionLabel={t(`${TRANSLATION_KEY}.addService`)}
      onAction={onAddService}
      dataTest="product-services-empty-state"
      actionDataTest="product-services-empty-add-button"
    />
  );
};
